const mStep = {
  title: 'Normal Review',
  description: 'Please provide details of the investment strategy review.',
};

export default {
  name: 'inv-strat-review-normal-review',
  data: () => ({
    mStep,
  }),
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    acknowledge: {
      get() {
        return this.getItem.review.normal.hasAcknowledge;
      },
      set(value) {
        this.setItem({ review: { normal: { hasAcknowledge: value } } });
      },
    },
  },
  methods: {
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
  validations: {
    acknowledge: {
      isChecked: value => (value === true),
    },
  },
};
